import request from '@/config/axios'

export interface AgentSettlePreviewVO {
  agentId?: number
  agentName?: string
  agentLevel?: number
  ledgerCount?: number
  softwares?: string
  totalAmount?: number
}

export interface AgentSettleItemVO {
  id?: number
  ledgerId?: number
  softwareId?: string
  merchantId?: number
  basisAmount?: number
  rate?: number
  amount?: number
}

export interface AgentSettleVO {
  id?: number
  settlementNo?: string
  agentId?: number
  agentName?: string
  agentLevel?: number
  period?: string
  totalAmount?: number
  status?: number
  bankName?: string
  bankAccountNo?: string
  bankAccountName?: string
  payVoucherNo?: string
  payTime?: string
  confirmTime?: string
  disputeReason?: string
  disputeHandleRemark?: string
  auditRemark?: string
  createTime?: string
  softwareSummary?: string
  items?: AgentSettleItemVO[]
}

export const previewSettle = (period: string) =>
  request.get<AgentSettlePreviewVO[]>({ url: '/agent/settle/preview', params: { period } })

export const collectSettle = (period: string) =>
  request.post<number>({ url: '/agent/settle/collect', data: { period } })

export const getSettlePage = (params: any) =>
  request.get<{ list: AgentSettleVO[]; total: number }>({ url: '/agent/settle/page', params })

export const getSettle = (id: number) =>
  request.get<AgentSettleVO>({ url: '/agent/settle/get', params: { id } })

export const auditSettle = (data: { id: number; approve: boolean; remark?: string }) =>
  request.put({ url: '/agent/settle/audit', data })

export const paySettle = (data: { id: number; payVoucherNo: string; remark?: string }) =>
  request.put({ url: '/agent/settle/pay', data })

export const handleSettleDispute = (data: { id: number; maintain: boolean; remark?: string }) =>
  request.put({ url: '/agent/settle/dispute-handle', data })
